import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button';
import PhoneInput from '../../PhoneInput';
import CustomControl from '../../CustomControl';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const PhoneForm = ({
  values,
  handleSubmit,
  handleChange,
  loading,
  requireHumanInput,
  blockLogin,
}) => {
  return (
    <Fragment>
      <p className="mb-4 px-md-6 text-center">
        We&apos;ll text you instructions on how to add photos to the live
        slideshow
      </p>
      <form
        onSubmit={handleSubmit}
        className="w-100 px-0 px-md-6 d-flex flex-column align-items-center"
      >
        <PhoneInput
          id="phone_number"
          label=""
          value={values.phone_number || '+1'}
          onChange={phone => {
            handleChange({
              target: {
                name: 'phone_number',
                value: phone,
              },
            });
          }}
          className="w-100 mb-0"
          autoFocus
        />
        {requireHumanInput && (
          <div className="w-100 mt-2 mb-1">
            <CustomControl
              type="checkbox"
              label="I'm not a robot"
              checked={values.force_allow_action}
              onChange={() =>
                handleChange({
                  target: {
                    name: 'force_allow_action',
                    value: !values.force_allow_action,
                  },
                })
              }
            />
          </div>
        )}
        <Button
          btnBlock
          type="submit"
          className="mt-2 mb-4"
          disabled={
            loading ||
            values.phone_number === '+1' ||
            blockLogin ||
            (requireHumanInput && !values.force_allow_action)
          }
        >
          {loading ? 'Sending...' : 'Continue'}
        </Button>
      </form>
    </Fragment>
  );
};

PhoneForm.propTypes = propTypes;

export default PhoneForm;
